import Link from "next/link";
import React from "react";
import GradientButton from "../Buttons/GradientButton";

interface Props {
  date: string;
  title: string;
  excerpt: string;
  link: string;
}

function formatDate(dateString: string) {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const dateObj = new Date(dateString);
  const month = months[dateObj.getMonth()];
  const day = dateObj.getDate();
  const year = dateObj.getFullYear();

  return `${day}, ${month}, ${year}`;
}

export default function BlogCard({ title, excerpt, date, link }: Props) {
  return (
    <div>
      <div className="flex items-start justify-evenly flex-col cursor-pointer hover:shadow-2xl hover:scale-105 md:hover:scale-110 transition-all duration-300 space-y-2 text-xs w-full min-h-[214px] h-[214px] p-4 text-gray-500 bg-white rounded-lg shadow-lg border">
        <div className="flex items-center space-x-1">
          <svg
            xmlns="https://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-4 h-4"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"
            />
          </svg>

          <p>{formatDate(date)}</p>
        </div>
        <Link href={`/guides/${link}`}>
          <h3 className="w-full text-lg font-semibold text-gray-700">
            {title}
          </h3>
          <p className="w-full">
            {excerpt.length > 120 ? `${excerpt.slice(0, 120)}....` : excerpt}
          </p>
        </Link>
        <div>
          <GradientButton
            text="Read Guide"
            textSize="text-xs"
            href={`/guides/${link}`}
          />
        </div>
      </div>
    </div>
  );
}
